<template>
  <div
    class="logo-container"
    :class="`${isDark ? 'dark' : ''} ${isScrolled ? 'scrolled' : ''} logged ${
      darkBackgroundCopy ? 'dark-background' : ''
    } ${lightBackground ? 'light-background' : ''} ${
      showResults && width > 1100 ? 'results' : ''
    }`"
  >
    <img
      v-if="
        !route?.name?.includes('register-coupon') ||
        route?.name === 'register-coupon' ||
        route?.name === 'register-coupon-validate-email' ||
        route?.name === 'register-coupon-validate-phone'
      "
      class="small-logo"
      :src="
        !isDark && !isScrolled
          ? '/logos/PALC_Full_Black.svg'
          : '/logos/PALC_Full_White.svg'
      "
      @click="router.push('/')"
    />
    <UtilsSearch
      ref="searchRef"
      :light-background="lightBackground"
      :is-scrolled="isScrolled"
      :dark-background="darkBackgroundCopy"
      @showSearchInput="showSearchInput = $event"
      v-show="
        width > 1100 &&
        (!route?.name?.includes('register-coupon') ||
          route?.name === 'register-coupon' ||
          route?.name === 'register-coupon-validate-email' ||
          route?.name === 'register-coupon-validate-phone')
      "
    />
    <div
      class="search-actions"
      :class="isUserLogged ? 'logged' : 'not-logged'"
      v-if="showSearchInput && width > 1100"
    >
      <ElButton
        :type="
          isScrolled || darkBackgroundCopy
            ? 'icon disabled with-blur lg'
            : lightBackground
            ? 'icon action-selected lg'
            : 'icon tins-dark-1 lg'
        "
        @click=";(showSearchInput = false), $eventBus.$emit('closeSearch')"
      >
        <Icons
          :name="
            lightBackground || isScrolled || darkBackgroundCopy
              ? '24px/close'
              : '24px/close_white'
          "
        />
      </ElButton>
    </div>
    <div
      class="donatella-actions"
      :class="isUserLogged ? 'logged' : 'not-logged'"
      v-if="
        !showSearchInput &&
        width > 1100 &&
        (!route?.name?.includes('register-coupon') ||
          route?.name === 'register-coupon' ||
          route?.name === 'register-coupon-validate-email' ||
          route?.name === 'register-coupon-validate-phone')
      "
    >
      <ElButton
        :type="
          isScrolled || darkBackgroundCopy
            ? 'icon disabled with-blur lg'
            : lightBackground
            ? 'icon action-selected lg'
            : 'icon tins-dark-1 lg'
        "
        @click="goToDonatella()"
      >
        <Icons
          :name="
            lightBackground || darkBackgroundCopy || isScrolled
              ? '24px/ai_2'
              : '24px/ai_2_white'
          "
        />
      </ElButton>
    </div>
    <div
      class="user-burguer-actions"
      v-if="
        !route?.name?.includes('register-coupon') ||
        route?.name === 'register-coupon' ||
        route?.name === 'register-coupon-validate-email' ||
        route?.name === 'register-coupon-validate-phone'
      "
    >
      <div
        :class="`actions-wrapper ${isUserLogged ? 'logged' : 'not-logged'} ${
          isScrolled || darkBackgroundCopy ? 'scrolled' : ''
        }`"
        @click="showUserMenuDrawer = true"
      >
        <ElButton type="icon" v-if="isUserLogged">
          <UtilsAvatar />
        </ElButton>
        <Icons
          :name="
            isScrolled || lightBackground || darkBackgroundCopy
              ? '24px/menu'
              : '24px/menu_white'
          "
        />
      </div>
    </div>
    <!-- drawer de usuario + menú -->
    <el-drawer
      :key="languageKey"
      v-model="showUserMenuDrawer"
      direction="rtl"
      class="left-drawer"
      :append-to-body="true"
      modal-class="left-drawer-modal user-menu-drawer"
    >
      <template #header>
        <img src="/logos/PALC_Full_Black.svg" alt="logo" class="logo-img" />
        <div class="section-divider" />
      </template>
      <div class="nav-section">
        <div
          v-if="isUserLogged"
          class="nav-item first-item logged"
          @click="router.push('/account'), (showUserMenuDrawer = false)"
        >
          <div class="user-image">
            <UtilsAvatar />
          </div>
          <div class="user-name">
            {{ getAuthUser()?.value?.first_name }}
          </div>
        </div>
        <div class="nav-item first-item not-logged" v-if="!isUserLogged">
          <ElButton
            type="primary dark"
            @click="router.push('/auth/register'), (showUserMenuDrawer = false)"
          >
            {{ $t('register') }}
          </ElButton>
          <ElButton
            type="secondary dark"
            @click="router.push('/login'), (showUserMenuDrawer = false)"
          >
            {{ $t('sign_in') }}
          </ElButton>
        </div>
        <div
          class="nav-item search-item"
          v-if="width <= 1100"
          @click="$refs.searchRef.search(), (showUserMenuDrawer = false)"
        >
          <Icons name="24px/search" />
          <span>{{ $t('search') }}</span>
        </div>
        <div
          class="nav-item donatella-item"
          @click="goToDonatella()"
          v-if="width <= 1100"
        >
          <Icons name="24px/ai_2" />
          <span>{{ $t('donatella') }}</span>
        </div>
        <div
          class="nav-item middle-item first"
          v-if="isUserLogged"
          @click="
            router.push('/your-itineraries'), (showUserMenuDrawer = false)
          "
        >
          {{ $t('itineraries') }}
        </div>
        <div
          class="nav-item middle-item"
          v-if="isUserLogged"
          @click="router.push('/reservations'), (showUserMenuDrawer = false)"
        >
          {{ $t('reservations') }}
        </div>
        <div
          class="nav-item middle-item"
          v-if="isUserLogged"
          @click="router.push('/digital-postcards'), (showUserMenuDrawer = false)"
        >
          {{ $t('digital_postcards') }}
        </div>
        <div
          class="nav-item middle-item"
          v-if="isUserLogged"
          @click="router.push('/nft-wallet'), (showUserMenuDrawer = false)"
        >
          {{ $t('nft_wallet') }}
        </div>
        <div
          class="nav-item middle-item"
          v-if="isUserLogged"
          @click="router.push('/my-membership'), (showUserMenuDrawer = false)"
        >
          {{ $t('membership') }}
        </div>
        <div
          class="nav-item middle-item last"
          v-if="isUserLogged"
          @click="router.push('/account'), (showUserMenuDrawer = false)"
        >
          {{ $t('account') }}
        </div>
        <div class="nav-item explore-accordion">
          <el-collapse accordion v-model="exploreAccordion">
            <el-collapse-item name="1">
              <template #title>
                <span class="body1">
                  {{ $t('explore') }}
                </span>
                <ElButton class="filter-icon" type="icon">
                  <Icons
                    name="24px/chevron_up"
                    v-if="exploreAccordion === '1'"
                  />
                  <Icons name="24px/chevron_down" v-else />
                </ElButton>
              </template>
              <div
                class="item"
                v-for="item in exploreItems"
                :key="item"
                @click="router.push(item.route), (showUserMenuDrawer = false)"
              >
                {{ $t(item.label) }}
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div class="nav-item language-accordion">
          <el-collapse accordion v-model="languageAccordion" v-if="myLanguage">
            <el-collapse-item name="1">
              <template #title>
                <div class="language-icon">
                  <span class="caption-strong">{{ myLanguage.iso_code }}</span>
                </div>
                <span class="body1">
                  {{ $t(`languages.${myLanguage.name}`) }}
                </span>
                <ElButton class="filter-icon" type="icon">
                  <Icons
                    name="24px/chevron_up"
                    v-if="languageAccordion === '1'"
                  />
                  <Icons name="24px/chevron_down" v-else />
                </ElButton>
              </template>
              <div
                class="item"
                :class="
                  languageSelected.toLowerCase() ===
                  language.iso_code.toLowerCase()
                    ? 'selected'
                    : ''
                "
                v-for="language in languages"
                :key="language.iso_code"
                @click="
                  $emit('setLocale', language.iso_code.toLowerCase()),
                    (languageAccordion = ''),
                    (languageSelected = language.iso_code.toLowerCase()),
                    (showUserMenuDrawer = false)
                "
              >
                <div class="language-icon">
                  <span class="caption-strong">{{ language.iso_code }}</span>
                </div>
                <div class="language-name">
                  {{ $t(`languages.${language.name}`) }}
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div class="nav-item last-item" v-if="isUserLogged">
          <ElButton
            type="link dark"
            @click="onLogout(), (showUserMenuDrawer = false)"
          >
            {{ $t('sign_out') }}
          </ElButton>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import LOGOUT from '~/graphql/auth/mutation/logout.gql'

export default defineComponent({
  name: 'Header',
  props: {
    isDark: {
      type: Boolean,
      default: false
    },
    darkBackground: {
      type: Boolean,
      default: false
    },
    lightBackground: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const { $eventBus } = useNuxtApp()
    const router = useRouter()
    const route = useRoute()
    const { width } = useBreakpoints()
    return {
      router,
      route,
      width,
      $eventBus
    }
  },
  data() {
    return {
      window,
      myLanguage: getLanguagesLanding()[0],
      languageSelected: 'en',
      languageKey: 0,
      isScrolled: false,
      showMenuNotLoggedDrawer: false,
      showMenuLoggedDrawer: false,
      showUserNotLoggedDrawer: false,
      showUserMenuDrawer: false,
      exploreAccordion: '',
      myParadiseAccordion: '',
      languageAccordion: '',
      showResults: false,
      showSearchInput: false,
      languages: getLanguagesLanding(),
      exploreItems: getExploreItems(),
      darkBackgroundCopy: false
    }
  },
  computed: {
    isUserLogged() {
      return getAuthUser()?.value?.uuid ? true : false
    }
  },
  watch: {
    '$i18n.locale': function (val) {
      this.languageSelected = val
      this.languageKey = setCustomKeyVariable()
      this.setMyLanguage()
    },
    darkBackground(newVal) {
      this.darkBackgroundCopy = newVal
    }
  },
  mounted() {
    if (this.isUserLogged) {
      this.languageSelected = getAuthUser()?.value?.language.toLowerCase()
    } else {
      this.languageSelected = this.$i18n.locale
    }
    this.setMyLanguage()
    this.darkBackgroundCopy = this.darkBackground

    this.$eventBus.$on('darkBackgroundCopy', (val) => {
      this.darkBackgroundCopy = val
    })

    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      if (window.scrollY > 0) {
        this.isScrolled = true
      } else {
        this.isScrolled = false
      }
    },
    async onLogout() {
      try {
        await mutation(LOGOUT)
        logout()
        window.location.href = '/'
      } catch (e) {
        this.$showError(e)
      }
    },
    resultsEvent(event) {
      this.showResults = event
      this.$emit('showResults', event)
    },
    setMyLanguage() {
      this.myLanguage = this.languages.find(
        (language) =>
          language.iso_code.toLowerCase() ===
          this.languageSelected.toLowerCase()
      )
    }
  }
})
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables/typography.scss';
.logo-container {
  width: 100%;
  z-index: 20;
  position: fixed;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 139px;
  background-color: transparent !important;
  &.results {
    z-index: 10000;
  }
  .small-logo {
    position: absolute;
    cursor: pointer;
    @media (min-width: 1100px) {
      left: 96px;
      height: 36px;
    }
    @media (max-width: 1100px) {
      height: 36px;
      left: 24px;
    }
  }
  .small-logo-text {
    position: absolute;
    cursor: pointer;
    @media (min-width: 1100px) {
      left: calc(96px + 24px + 10px);
      height: 30px;
    }
    @media (max-width: 1100px) {
      height: 26px;
      left: calc(24px + 24px + 4px);
    }
  }
  .full-logo {
    width: 150px;
    height: 75px;
    cursor: pointer;
  }
  @media (min-width: 1100px) {
    justify-content: center;
    padding: 32px 96px;
  }
  @media (max-width: 1100px) {
    justify-content: center;
    padding: 32px 24px;
  }
  .language-selector {
    display: flex;
    position: absolute;
    cursor: pointer;
    @media (min-width: 1100px) {
      right: 330px;
      top: 77px;
      height: 24px;

      &.scrolled {
        top: 24px !important;
      }

      &.logged {
        top: 24px !important;
        right: 210px !important;
      }
    }
    @media (max-width: 1100px) {
      //
    }
    .selector {
      .body2 {
        color: var(--brand-off-black);
      }
      .body2-underline {
        color: var(--brand-off-black);
      }
    }
  }
  .login-actions {
    position: absolute;
    @media (min-width: 1100px) {
      right: 96px;
      height: 75px;
    }
    @media (max-width: 1100px) {
      height: 75px;
      right: 24px;
    }
    .actions {
      position: relative;
      top: 36px;
      span {
        cursor: pointer;
      }
      .el-button {
        margin-left: 24px !important;
      }
    }
  }
  .search-actions {
    position: absolute;
    @media (min-width: 1100px) {
      right: 186px;
      height: 75px;
    }
    display: flex;
    align-items: center;
    z-index: 2;
    &.not-logged {
      @media (min-width: 1100px) {
        right: 160px;
      }
    }
  }
  .donatella-actions {
    position: absolute;
    @media (min-width: 1100px) {
      right: 186px;
      height: 75px;
    }
    display: flex;
    align-items: center;
    &.not-logged {
      @media (min-width: 1100px) {
        right: 160px;
      }
    }
  }
  .user-burguer-actions {
    position: absolute;
    @media (min-width: 1100px) {
      right: 96px;
      height: 75px;
    }
    @media (max-width: 1100px) {
      height: 75px;
      right: 16px;
    }
    display: flex;
    align-items: center;
    .actions-wrapper {
      cursor: pointer;
      display: flex;
      align-items: center;
      padding: 4px;
      gap: 4px;
      border-radius: 100px;
      background: var(--tins-dark-1);
      backdrop-filter: blur(5px);
      &.not-logged {
        height: 48px;
        width: 48px;
        justify-content: center;
      }
    }
  }

  &.dark {
    .language-selector {
      .selector {
        .body2 {
          color: var(--brand-white);
        }
        .body2-underline {
          color: var(--brand-white);
        }
      }
    }
    .login-actions {
      .actions {
        span {
          color: var(--brand-white);
        }
      }
    }
  }

  &.dark-background {
    background-color: var(--brand-off-black) !important;
    backdrop-filter: blur(7.5px);
    .user-burguer-actions {
      .actions-wrapper {
        background-color: var(--brand-mid-grey) !important;
      }
    }
  }

  &.light-background {
    background-color: var(--brand-white) !important;
    .user-burguer-actions {
      .actions-wrapper {
        background-color: var(--action-selected) !important;
      }
    }
  }

  &.logged {
    height: 68px;
    @media (min-width: 1100px) {
      padding: 16px 96px;
    }
    @media (max-width: 1100px) {
      padding: 16px 24px;
    }
  }

  &.scrolled {
    height: 68px;
    @media (min-width: 1100px) {
      padding: 16px 96px;
    }
    @media (max-width: 1100px) {
      padding: 16px 24px;
    }
    background-color: var(--brand-off-black) !important;
    backdrop-filter: blur(7.5px);
    .login-actions {
      .actions {
        top: 18px !important;
        span {
          color: var(--brand-white);
        }
      }
    }
    .language-selector {
      .selector {
        .body2 {
          color: var(--brand-white);
        }
        .body2-underline {
          color: var(--brand-white);
        }
      }
    }
    .user-burguer-actions {
      .actions-wrapper {
        background-color: var(--brand-mid-grey) !important;
      }
    }
  }
}

.left-drawer-modal {
  .left-drawer {
    .el-drawer__header {
      img {
        @media (max-width: 1100px) {
          position: absolute;
          top: 32px;
          left: calc(50% - 65px);
          height: 32px;
        }
        @media (min-width: 1100px) {
          height: 32px;
          position: absolute;
          top: 32px;
          left: 24px;
        }
      }
      .section-divider {
        width: calc(100% - 48px);
        height: 1px;
        background-color: var(--divisor-line);
        position: absolute;
        top: calc(16px + 50px + 16px);
      }
    }
    .el-drawer__body {
      margin-top: 32px;
      .nav-section {
        padding: 0 0 16px 0;
        .nav-item {
          @extend .body1;
          color: var(--brand-off-black);
          &.middle-item {
            cursor: pointer;
            height: 42px;
            display: flex;
            align-items: center;
            &.first {
              height: calc(42px + 24px) !important;
              padding: 24px 0 0 0 !important;
              border-top: 1px solid var(--divisor-line);
            }
            &.last {
              height: calc(42px + 24px) !important;
              padding: 0 0 24px 0 !important;
            }
          }

          &.first-item {
            @extend .body1-strong;
            height: 88px !important;
            &.logged {
              display: flex;
              align-items: center;
              .user-image {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                background-color: var(--brand-white);
                display: inline-flex;
                justify-content: center;
                align-items: center;
                i {
                  position: relative;
                  left: 1px;
                }
              }
              .user-name {
                margin-left: 8px;
                max-width: 300px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }

            &.not-logged {
              margin-top: 24px;
              margin-bottom: 24px;
              .el-button {
                width: 100%;
                &:nth-of-type(2) {
                  margin-top: 16px;
                }
              }
            }
          }

          &.language-accordion {
            padding: 24px 0 0 0 !important;
          }

          &.explore-accordion {
            padding: 16px 0 0 0 !important;
            border-top: 1px solid var(--divisor-line);
          }

          &.last-item {
            padding: 24px 0 0 0 !important;
          }

          &.search-item {
            padding: 16px 0 16px 0;
            cursor: pointer;
            border-top: 1px solid var(--divisor-line);
            i {
              display: inline-block;
              margin-right: 16px;
            }
            span {
              position: relative;
              top: -5px;
            }
          }

          &.donatella-item {
            cursor: pointer;
            padding: 0 0 16px 0;
            i {
              display: inline-block;
              margin-right: 16px;
            }
            span {
              position: relative;
              top: -5px;
            }
          }

          :deep(.el-collapse) {
            width: 100%;
            border: 0 !important;
            .el-collapse-item {
              border: 0 !important;
              .el-collapse-item__header {
                background-color: var(--brand-off-white) !important;
                border: 0 !important;
                position: relative;
                text-align: left;
                min-height: 48px;
                height: 48px;
                i.el-icon {
                  display: none;
                }
                .filter-icon {
                  position: absolute;
                  right: 0 !important;
                  top: 3px !important;
                }
                .language-icon {
                  background-color: var(--brand-off-black);
                  color: var(--brand-white);
                  width: 30px;
                  height: 30px;
                  border-radius: 50%;
                  margin-right: 8px;
                  display: inline-flex;
                  justify-content: center;
                  align-items: center;
                }
              }
              .el-collapse-item__wrap {
                margin: 0px 8px 8px 24px;
                border-bottom: 1px solid var(--brand-off-white) !important;
                .el-collapse-item__content {
                  background-color: var(--brand-off-white) !important;
                  padding-top: 4px;
                  padding-bottom: 0 !important;
                  .item {
                    cursor: pointer;
                    @extend .body1;
                    &:not(:first-of-type) {
                      margin-top: 16px;
                    }

                    .language-icon {
                      background-color: var(--brand-off-white);
                      color: var(--brand-off-black);
                      width: 28px;
                      height: 28px;
                      border-radius: 50%;
                      margin-right: 8px;
                      display: inline-flex;
                      justify-content: center;
                      align-items: center;
                    }
                    .language-name {
                      display: inline-block;
                    }
                    &.selected {
                      @extend .body1-strong;
                      .language-name {
                        position: relative;
                        top: 2px;
                      }
                      .language-icon {
                        background-color: var(--brand-off-black);
                        color: var(--brand-white);
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
